import { useMemo } from "react";
import { AppExperienceData } from "../types/experience";

export const useHideItem = (itemName: string, experience: AppExperienceData) => {
  const item: boolean | undefined = useMemo(() => {
    const uxControls = experience?.ux_controls || [];
    const control = uxControls.find((c) => c.control === itemName);
    return control?.value === "true";
  }, [experience, itemName]);
  return item;
};
